import React, { useRef, useCallback } from 'react';

// Logo tarzı Enter-ile-alan-gezme. Formun alanlarını sar:
//   <EnterNavForm onSubmit={handleKaydet} onRowAdd={addKalem}> ...alanlar... </EnterNavForm>
// Sözleşme (tasarım: docs/plans/2026-06-23-enter-ile-alan-gecisi-design.md):
//  - textarea → Enter=newline (dokunma)        - button/submit → bırak
//  - e.defaultPrevented (autocomplete açık) → dokunma
//  - data-enter-nav="off" → bu alanda devre dışı
//  - data-enter-nav="row-add" → onRowAdd (kalem satırı): varsa sonraki satıra, son satırsa yeni satır
//  - aksi → sonraki odaklanabilir alana geç; yoksa onSubmit()
const FOCUSABLE = 'input:not([type=hidden]):not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

// Not: Görünürlük React koşullu render ile yönetiliyor (display:none değil), bu yüzden
// offsetParent kontrolüne gerek yok — jsdom testleri de böylece çalışır.
function getFocusables(container) {
  if (!container) return [];
  return Array.from(container.querySelectorAll(FOCUSABLE));
}

export default function EnterNavForm({ onSubmit, onRowAdd, children, ...rest }) {
  const ref = useRef(null);

  const handleKeyDown = useCallback((e) => {
    if (e.key !== 'Enter') return;
    if (e.defaultPrevented) return;
    const el = e.target;
    const tag = el.tagName;
    if (tag === 'TEXTAREA') return;              // newline
    if (tag === 'BUTTON' || el.type === 'submit') return;
    if (el.dataset && el.dataset.enterNav === 'off') return;

    // Kalem satırı: tutar hücresinde Enter → sonraki satır / yeni satır
    if (el.dataset && el.dataset.enterNav === 'row-add') {
      e.preventDefault();
      const row = el.closest('[data-enter-row]');
      const nextRow = row && row.nextElementSibling;
      if (nextRow && nextRow.matches && nextRow.matches('[data-enter-row]')) {
        const inp = getFocusables(nextRow)[0];
        if (inp) inp.focus();
      } else if (onRowAdd) {
        onRowAdd();
        requestAnimationFrame(() => {
          const rows = ref.current ? ref.current.querySelectorAll('[data-enter-row]') : [];
          const last = rows[rows.length - 1];
          const inp = getFocusables(last)[0];
          if (inp) inp.focus();
        });
      }
      return;
    }

    e.preventDefault();
    const focusables = getFocusables(ref.current);
    const idx = focusables.indexOf(el);
    if (idx === -1) return;
    const next = focusables[idx + 1];
    if (next) next.focus();
    else if (onSubmit) onSubmit();
  }, [onSubmit, onRowAdd]);

  return (
    <div ref={ref} onKeyDown={handleKeyDown} {...rest}>
      {children}
    </div>
  );
}
